import SharedInput, { type IInputProps } from "../../../../ui/src/input/Input";
import { useLocale } from "../../hooks/useLocale";
import { displayText } from "../../locales/display";
import { msg } from "../../locales/translate";

export * from "../../../../ui/src/input/Input";

export default function Input(props: IInputProps) {
	useLocale();
	return <SharedInput {...props} switchboxLabels={{
		yes: props.switchboxLabels ? displayText(props.switchboxLabels.yes) : msg("yes"),
		no: props.switchboxLabels ? displayText(props.switchboxLabels.no) : msg("no"),
	}} />;
}
